import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { firebaseAuth } from '@/integrations/firebase'

export const Route = createFileRoute('/onboarding')({
  component: OnboardingPage,
})

function OnboardingPage() {
  const { t } = useTranslation()

  return (
    <div className="p-4 md:pt-10 flex flex-col w-full items-center h-screen bg-background">
      <div className="w-[min(100%,_880px)] h-full flex flex-col items-start relative">
        <Button
          className="absolute top-0 left-0"
          onClick={() => firebaseAuth.signOut()}
          variant="secondary"
        >
          {t('global.signOut')}
        </Button>
        <div className="flex flex-col items-center gap-10 justify-center flex-1 mx-auto w-[678px]">
          <h1 className="text-3xl font-bold animate-in duration-500 delay-100 fade-in-0 slide-in-from-bottom-10 fill-mode-backwards">
            {t('onboardingPage.title')}
          </h1>
          <div className="flex flex-col items-center gap-5 animate-in duration-500 slide-in-from-bottom-20 fade-in-0 delay-300 fill-mode-backwards">
            <Link to="/">
              <Button className="min-w-[400px]" size="lg">
                {t('onboardingPage.addIndividualButton')}
              </Button>
            </Link>
            <p className="max-w-[50ch] text-center text-lg">{t('onboardingPage.helperText')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
